/** @generated - do not modify this file. */

// src/schema.ts
import { schema } from '@verdant-web/store'
import cuid from 'cuid'
var habits = schema.collection({
  name: 'habit',
  primaryKey: 'id',
  fields: {
    id: schema.fields.string({
      default: cuid,
    }),
    name: schema.fields.string({
      default: '',
    }),
    createdAt: schema.fields.number({
      default: () => Date.now(),
    }),
    updatedAt: schema.fields.number({
      default: () => Date.now(),
    }),
    description: schema.fields.string({
      default: '',
    }),
  },
})
var records = schema.collection({
  name: 'record',
  primaryKey: 'id',
  fields: {
    id: schema.fields.string(),
    parentId: schema.fields.string(),
    date: schema.fields.string(),
    description: schema.fields.string({
      default: '',
    }),
    status: schema.fields.string({
      options: ['done', 'skip', 'fail'],
    }),
  },
})
var schema_default = schema({
  version: 2,
  collections: {
    habits,
    records,
  },
})
export { schema_default as default }
